export default "https://c.travel-assets.com/partner-portal/worldwide.97830d67b74b.svg";